//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "BasicEncuesta",
  props: {
    value: Number,
    pregunta: String,
    min: Number,
    max: Number,
    readOnly: Boolean,
    labels: Array
  },
  data() {
    return {
      respuesta: this.value
    };
  },
  methods: {
    sendRespuesta(val) {
      this.respuesta = val;
      this.$emit("input", this.respuesta);
    }
  }
};
